import Icon from 'components/Icon/Icon.component';
import CloseIcon from 'images/icons/close-icon.svg?react';
import React from 'react';
import { CloseButtonPrimaryVariantRoot } from '../style/Modal.style';

type CloseButtonProps = {
  iconSize?: string;
  onClick: () => void;
};

const CloseButton = React.memo(function CloseButton({
  onClick,
  iconSize,
  ...otherProps
}: CloseButtonProps) {
  return (
    <CloseButtonPrimaryVariantRoot
      {...otherProps}
      onClick={onClick}
      data-modal-close="true"
    >
      <Icon
        iconSize={iconSize}
        svgIconComponent={CloseIcon}
        aria-hidden="true"
      />
    </CloseButtonPrimaryVariantRoot>
  );
});

export default CloseButton;
